let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ajogb")).then(() => parcelRequire('aW5YP'));